<script>
    import { MaterialAppMin, Container, TextField, Overlay, ProgressCircular, NavigationDrawer, Subheader, Icon, List, ListItem, ListGroup, ListItemGroup, Col, Row, Select, Switch } from 'svelte-materialify/src';
    import { mdiChevronUp, mdiCog, mdiMapLegend } from "@mdi/js";
	

</script>

<MaterialAppMin theme="light">
    <slot style="position: fixed"></slot>
    <Container>
        <h2 class="text-h2 font-weight-thin">Accessibility for Color Vision Deficiencies: Challenges and
            Findings of a Large Scale Study on Paper Figures</h2>

        <center>
            <img src="./img/teaser.png" alt="teaser" />
        </center>
        <br>
        
        <h3 class="text-overline font-weight-black">Abstract</h3>
        <p> 
            We present an exploratory study on the accessibility of images
            in publications when viewed with color vision deficiencies (CVDs).
            The study is based on 1710 images sampled from a visualization
            dataset (VIS30K) over five years. We simulated four CVDs on each
            image. First, four researchers (one with a CVD) identified existing
            issues and helpful aspects in a subset of the images. Based on
            the resulting labels, 200 crowdworkers provided 30,000 ratings on
            present CVD issues in the simulated images. We analyzed this data
            for correlations, clusters, trends, and free text comments to gain a
            first overview of paper figure accessibility. Overall, about 60 % of
            the images were rated accessible. Furthermore, our study indicates
            that accessibility issues are subjective and hard to detect. On a meta-level, we reflect on our study experience to point out challenges and
            opportunities of large-scale accessibility studies for future research
            directions.
        </p>
    </Container>
</MaterialAppMin>

<style>
    img {
        margin-top: 2em;
        max-width: 100%;
    }

    h2 {
        margin-top: 3rem;
    }
    
</style>